import {
  ORDER_STATUS_DISPATCHED,
  PO_ORDER_TAG_DIRECT_DELIVERY,
  PO_ORDER_TAG_MANDI_DD,
  PO_STATUS,
  SELLER_ACTION_STATUS_COMPLETED,
  SELLER_ACTION_STATUS_PENDING,
} from "utils/constants/others";
import { strings } from "utils/constants/strings";

export const DD_PO_PAGE_SIZE = 20;

export const DD_PO_PAGES = {
  PENDING_INVOICE: "PENDING_INVOICE",
  PENDING_DELIVERY: "PENDING_DELIVERY",
  DELIVERED: "DELIVERED",
};

export const DD_PO_PAGE_CONFIG = [
  {
    key: DD_PO_PAGES.PENDING_INVOICE,
    label: strings.pendingInvoice,
    getParams: (outletId) => ({
      vendor_id: outletId,
      is_item_required: true,
      po_status: PO_STATUS.APPROVED,
      fetch_invoice: true,
      fetch_po_with_no_seller_invoice: true,
      order_tags: `${PO_ORDER_TAG_MANDI_DD},${PO_ORDER_TAG_DIRECT_DELIVERY}`,
      filter_direct_delivery_by_order_ref: true,
    }),
  },
  {
    key: DD_PO_PAGES.PENDING_DELIVERY,
    label: strings.pendingDelivery,
    getParams: (outletId) => ({
      vendor_id: outletId,
      is_item_required: true,
      fetch_invoice: true,
      fetch_po_with_no_seller_invoice: false,
      order_status: `${ORDER_STATUS_DISPATCHED},${SELLER_ACTION_STATUS_COMPLETED}`,
      seller_action_status: SELLER_ACTION_STATUS_PENDING,
      order_tags: `${PO_ORDER_TAG_MANDI_DD},${PO_ORDER_TAG_DIRECT_DELIVERY}`,
      po_status: PO_STATUS.APPROVED,
    }),
  },
  {
    key: DD_PO_PAGES.DELIVERED,
    label: strings.delivered,
    getParams: (outletId) => ({
      vendor_id: outletId,
      is_item_required: true,
      fetch_invoice: true,
      fetch_po_with_no_seller_invoice: false,
      seller_action_status: SELLER_ACTION_STATUS_COMPLETED,
      is_payment_details_required: true,
      order_tags: `${PO_ORDER_TAG_MANDI_DD},${PO_ORDER_TAG_DIRECT_DELIVERY}`,
      po_status: `${PO_STATUS.APPROVED},${PO_STATUS.COMPLETED}`,
    }),
  },
];

export const getDDPoPageConfig = (page) =>
  DD_PO_PAGE_CONFIG.find((config) => config.key === page) || DD_PO_PAGE_CONFIG[0];

export const getDDPoPageConfigByIndex = (index) => DD_PO_PAGE_CONFIG[index] || DD_PO_PAGE_CONFIG[0];
